import React, { useEffect, useRef } from 'react';
import { Container, Graphics } from '@pixi/react';
import { observer } from 'mobx-react-lite';
import { Spine } from '../../core/classes/spine';
import { gameResourcesService } from '../../services/gameResourcesService';
import WebBottomContainer from '../../containers/web/bottom';
import MenuWrapper from '../../containers/common/menuWrapper';
import Notification from '../../containers/common/notification';
import WinLineWrapper from '../../containers/common/winLineWrapper';
import FreeBetWrapper from '../../containers/common/freeBetWrapper';
import GameLogoWrapper from '../../containers/common/gameLogoWrapper';
import WinPopupWrapper from '../../containers/common/winPopupWrapper';
import InfoSectionContainer from '../../containers/common/infoWrapper';
import GameBoardWrapper from '../../containers/common/gameBoardWrapper';
import LobbyIconWrapper from '../../containers/common/lobbyIconWrapper';
import ExpandWildWrapper from '../../containers/common/expandWildWrapper';
import JackPotInfoWrapper from '../../containers/common/jackPotInfoWrapper';
import TournamentIconWrapper from '../../containers/common/tournamentIconWrapper';
import GameBackgroundWrapper from '../../containers/common/gameBackgroundWrapper';
import ConnectionPopupWrapper from '../../containers/common/connectionPopupWrapper';
import Gamble from '../../components/common/gamble';
import JackpotScene from '../../components/common/jackpotScene';
import JackPotCongratsPopup from '../../components/common/jackpot/jackPotCongratsPopup';
import BoostedJackpot from '../../components/common/boostedJackpot';
import BoostedJackpotIcon from '../../components/common/boostedJackpotIcon';
import RePlayInfoIconWrapper from '../../containers/common/rePlayInfoIconWrapper';

const WebView = observer(({ setMask, reelContainerRef, winContainerRef, reelContainerConfig }) => {
  const spriteMaskRef = useRef(null);
  const gameSceneShakeSpineRef = useRef(null);
  const shakeContainerRef = useRef(null);

  useEffect(() => {
    if (spriteMaskRef.current) {
      setMask(spriteMaskRef.current);
    }
  }, [setMask, spriteMaskRef]);

  useEffect(() => {
    const gameSceneShakeSpine = new Spine({ key: 'shake' });
    gameSceneShakeSpine.x = 0;
    gameSceneShakeSpine.y = 0;
    gameResourcesService.setShakeSpine(gameSceneShakeSpine);
    gameSceneShakeSpine.addChildToSlot('shake', shakeContainerRef.current);
    gameSceneShakeSpineRef.current.addChild(gameSceneShakeSpine);
  }, []);

  return (
    <>
      <Container ref={gameSceneShakeSpineRef} name='GameSceneShakeContainer'>
        <Container ref={shakeContainerRef}>
          <GameBackgroundWrapper />
          <GameBoardWrapper />
          <GameLogoWrapper />
          <Container ref={reelContainerRef} {...reelContainerConfig} name='ReelContainer'>
            <Graphics
              draw={(g) => {
                g.beginFill(0xff700b);
                g.drawRect(8, -77, 985, 591.5);
              }}
              ref={(graphicsRef) => setMask(graphicsRef)}
            />
          </Container>
        </Container>
      </Container>
      <Container ref={winContainerRef} {...reelContainerConfig} name='WinContainer' />
      <ExpandWildWrapper />
      <WinLineWrapper />
      <WinPopupWrapper />
      <WebBottomContainer />
      <TournamentIconWrapper />
      <LobbyIconWrapper />
      <RePlayInfoIconWrapper />
      <BoostedJackpotIcon />
      <JackPotInfoWrapper />
      <Gamble />
      <FreeBetWrapper />
      <BoostedJackpot />
      <InfoSectionContainer />
      <MenuWrapper />
      <JackPotCongratsPopup />
      <JackpotScene />
      <Notification />
      <ConnectionPopupWrapper />
    </>
  );
});

export default WebView;
